import { Button, HStack } from "@chakra-ui/react";
import { MapPinIcon, SquaresFourIcon } from "@phosphor-icons/react/dist/ssr";

// Floating two-segment control at bottom-center on mobile (<lg). Both
// segments are always visible so the user can see the alternate view
// without first tapping into it (Zillow pattern). The currently-selected
// segment fills with the accent palette; the unselected segment is
// transparent over the dark pill chrome so its label still reads. Tap
// the unselected segment to switch; tapping the already-selected segment
// is a no-op.
const MobileViewToggle = ({ viewMode, onChange }) => {
    const segments = [
        { mode: "list", label: "Lista", Icon: SquaresFourIcon },
        { mode: "map", label: "Mapa", Icon: MapPinIcon },
    ];
    return (
        <HStack
            display={{ base: "inline-flex", lg: "none" }}
            position="fixed"
            bottom={6}
            left="50%"
            transform="translateX(-50%)"
            zIndex={1000}
            gap={1}
            p={1.5}
            rounded="full"
            bg="white"
            borderWidth="1px"
            borderColor="gray.200"
            boxShadow="0 6px 16px rgba(0,0,0,0.3)"
            aria-label="Cambiar vista"
            role="tablist"
        >
            {segments.map(({ mode, label, Icon }) => {
                const selected = viewMode === mode;
                return (
                    <Button
                        key={mode}
                        role="tab"
                        aria-selected={selected}
                        onClick={() => {
                            if (!selected) onChange(mode);
                        }}
                        rounded="full"
                        h="36px"
                        px={4}
                        fontWeight={600}
                        fontSize="sm"
                        bg={selected ? "accent.500" : "transparent"}
                        color={selected ? "white" : "gray.700"}
                        _hover={{
                            bg: selected ? "accent.600" : "gray.100",
                        }}
                    >
                        <Icon weight="bold" />
                        {label}
                    </Button>
                );
            })}
        </HStack>
    );
};

export default MobileViewToggle;
